export const usePrefixCls = (tag, props) => {
    const prefix = props?.prefix ?? 'cn-ui-m-';
    return `${prefix}${tag ?? ''}`;
};
